import { GET_TICKET_ANALYTIC, GET_TICKET_ANALYTIC_SUCCESS, GET_TICKET_ANALYTIC_ERROR, GET_TICKET_ANALYTIC_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetTicketAnalytic = (state = initialState, action) => {
  switch (action.type) {
    case GET_TICKET_ANALYTIC:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_TICKET_ANALYTIC_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_TICKET_ANALYTIC_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_TICKET_ANALYTIC_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetTicketAnalytic;
